import { render, staticRenderFns } from "./ConfirmCodeForm.vue?vue&type=template&id=1870abf4&scoped=true&"
import script from "./ConfirmCodeForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmCodeForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authorization.css?vue&type=style&index=0&id=1870abf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1870abf4",
  null
  
)

export default component.exports